import React, { useState } from "react";
import { DatePicker, Row } from "antd";
import moment, { Moment } from "moment";

type RangePickerValue = [Moment | undefined, Moment | undefined];

interface DateRangePickerProps {
  value?: RangePickerValue;
  minDate?: Moment;
  required?: boolean;
  onChange?: (value: RangePickerValue) => void;
}

function RangePicker({ value = [undefined, undefined], minDate, required, onChange }: DateRangePickerProps) {
  const [start, setStart] = useState<Moment>();
  const [end, setEnd] = useState<Moment>();

  const startValue = value?.[0] ?? start;
  const endValue = value?.[1] ?? end;

  const isOutOfRange = (date: Moment) =>
    (minDate != null && date.isBefore(minDate, "day")) || date.isAfter(moment(), "day");

  return (
    <Row align={"middle"}>
      <DatePicker
        mode="date"
        placeholder="Start date"
        allowClear={!required}
        value={startValue}
        onChange={(val) => {
          const v = val?.clone().startOf("day") ?? undefined;
          setStart(v);
          if (onChange) {
            onChange([v, endValue]);
          }
        }}
        disabledDate={(date) => isOutOfRange(date) || (endValue != null && date.isAfter(endValue, "day"))}
        style={{ flexGrow: 1 }}
      />
      <span style={{ margin: "0 12px" }}>to</span>
      <DatePicker
        mode="date"
        placeholder="End date"
        allowClear={!required}
        value={endValue}
        onChange={(val) => {
          const v = val?.clone().endOf("day") ?? undefined;
          setEnd(v);
          if (onChange) {
            onChange([startValue, v]);
          }
        }}
        disabledDate={(date) => isOutOfRange(date) || (startValue != null && date.isBefore(startValue, "day"))}
        style={{ flexGrow: 1 }}
      />
    </Row>
  );
}

export default RangePicker;
